import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { FaConfig, FaIconLibrary } from '@fortawesome/angular-fontawesome';

export function provideIcons (): EnvironmentProviders {
	return makeEnvironmentProviders([
		provideAppInitializer(async () => {
			const faConfig = inject(FaConfig);
			faConfig.defaultPrefix = 'far';
			await registerIcons(inject(FaIconLibrary));
		})
	]);
}

export async function registerIcons (library: FaIconLibrary): Promise<void> {
	const { all } = await import('@awesome.me/kit-76d76e9b5a/icons');
	library.addIcons(...all);
}
